import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { Http, Response } from '@angular/http'
import { Favorites } from './favorite'
@Component({
  selector: 'app-fullmovie',
  templateUrl: './fullmovie.component.html',
  styleUrls: ['./fullmovie.component.css']
})
export class FullmovieComponent implements OnInit {
  data: ObjectConstructor
  id: string
  loading: boolean

  constructor(public route: ActivatedRoute, public http: Http, public favorites: Favorites) { }

  ngOnInit() {
    this.id = this.route.snapshot.params['id']
    this.loading = true
    this.http.request(`https://cors-everywhere.herokuapp.com/http://www.omdbapi.com/?i=${this.id}&plot=full&apikey=e51cc621`)
      .subscribe((res: Response) => {
        this.loading = false
        this.data = res.json()
       
      })

  }
  Favorite(data) {
    this.favorites.addToFavorites(data)

  }

}
